const staticPages = {
    comingSoon: 'səhifə dizayn edilir',
};

export default staticPages;
